import React from 'react';
import { cn } from '../../shared/util/cn';

export interface SheetProps extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  onClose: () => void;
  side?: 'left' | 'right';
  width?: number | string;
}

export const Sheet: React.FC<SheetProps> = ({
  open,
  onClose,
  side = 'right',
  width = 280,
  className,
  children,
  ...props
}) => {
  if (!open) return null;

  const widthStyle = typeof width === 'number' ? { width: `${width}px` } : { width };

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm transition-opacity duration-300 ease-out"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        role="dialog"
        aria-modal="true"
        className={cn(
          'fixed top-0 h-full z-50 overflow-y-auto bg-surface border-l border-[var(--color-mockup-border)] shadow-dropdown transition-transform duration-300 ease-out',
          side === 'right' ? 'right-0' : 'left-0',
          className
        )}
        style={widthStyle}
        {...props}
      >
        {children}
      </div>
    </>
  );
};
Sheet.displayName = 'Sheet';
